"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * API Portal Solutions components
 * By Dharma Adusumilli <dadusumilli@svb.com> (www.svb.com)
 * Summary
 * This component renders a Solutions Header
 */

/**
 * SVBSlogans
 * @param sloganContent: strings like title, description and image
 * see ../readme.MD for sample body
 * @param title: slogan title
 * @param description: slogan description
 * @param image: image for the slogan
 * @returns slogan HTML with content
 */
const SVBSolutionsSlogan = _ref => {
  let {
    type,
    title,
    description,
    image,
    bgColor,
    width,
    breadCrumbs,
    extraClasses
  } = _ref;
  const titleTypography = type === "headerBlock" ? 'heading-xlarge' : type === "bodyBlock" ? 'heading-large' : type ? type : 'heading-large';
  const img = image ? type === "headerBlock" ? {
    backgroundImage: "url(".concat(image, ")"),
    backgroundSize: '50%'
  } : {
    backgroundImage: "linear-gradient(90deg, rgba(255, 255, 255, 0.93) 17.71%, rgba(255, 255, 255, 0.68) 42.19%, rgba(255, 255, 255, 0.22) 55.73%, rgba(255, 255, 255, 0) 83.33%), url(".concat(image, ")")
  } : {};
  const maxWidth = type === "headerBlock" ? {
    maxWidth: "650px"
  } : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "solutions-slogan slogan d-flex ".concat(extraClasses, " ").concat(type, " ").concat(bgColor, " ").concat(width),
    style: img
  }, breadCrumbs && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBBreadCrumb, {
    breadCrumbs: breadCrumbs,
    extraClasses: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: type === "headerBlock" ? "slogan-text w-50" : "slogan-text",
    style: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: titleTypography
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "sub-heading-large sol-description"
  }, description)));
};
var _default = exports.default = SVBSolutionsSlogan;